















import {Component, Prop, Vue} from 'vue-property-decorator';
import {mixin as clickaway} from 'vue-clickaway';
import {ConditionViewModel} from './models/conditionViewModel';
import { IConditionsManager } from './models/conditionsManager';
import DateTimeCondition from './configComponents/DateTimeCondition.vue';
import TextCondition from './configComponents/TextCondition.vue';
import DecimalCondition from './configComponents/DecimalCondition.vue';
import NumberCondition from './configComponents/NumberCondition.vue';
import ListCondition from './configComponents/ListCondition.vue';
import DurationCondition from './configComponents/DurationCondition.vue';
import IntentCondition from '@/features/bots/components/designer/Conditions/IntentCondition.vue';
import TimeOfDayCondition from './configComponents/TimeOfDayCondition.vue';
import { ConditionOperationType } from '@/shared/components/conditions/models/conditions';

@Component({
	mixins: [
		clickaway,
	],
	components: {
		DateTimeCondition,
		TextCondition,
		NumberCondition,
		DecimalCondition,
		ListCondition,
		DurationCondition,
		IntentCondition,
		TimeOfDayCondition
	}
})
export default class ConditionConfigurator extends Vue {
	@Prop() public value: ConditionViewModel;
	@Prop() public manager: IConditionsManager;


	public condition: ConditionViewModel = {
		attribute: '',
		operation: '',
		type: '',
		unit: '',
		value: '',
		result: true
	};

	public mounted() {
		if (this.value) {
			this.condition = {
				attribute: this.value.attribute,
				operation: this.value.operation,
				type: this.mappedType,
				unit: this.value.unit,
				value: this.value.value,
				result: this.value.result,
				invalid: this.value.invalid,
			};
		}
	}

	public getConditionConfigComponent() {
		return this.manager.getConfigComponent(this.condition);
	}

	public getConditionOptions() {
		return this.manager.getConditionOptions(this.condition);
	}

	public conditionUpdated(update: ConditionViewModel) {
		// pass up any changes as they happen, so that the parent has the up-to-date state
		// if the config is closed by clicking away
		if (update.operation === ConditionOperationType.IsSet) {
			update.value = '';
			update.unit = undefined;
		}

		this.condition = update;
		this.$emit('updated', this.condition);
	}

	public onConfigChanged(update: ConditionViewModel) {
		// let the parent know that the config has been closed by clicking the done button
		this.condition = update;
		this.$emit('completed', this.condition);
	}

	private get mappedType(): string {
		const mappings: { [key: string]: string } = {
			seconds: 'duration'
		};
		return mappings[this.value.type] != null ? mappings[this.value.type] : this.value.type;
	}
}
